import { put, call, takeLatest } from 'redux-saga/effects';
import * as api from './Api';
import { actions } from './Reducer';
import {
  setMyArtisanPrivateInquiryIsLoading,
  // getArtisanPrivateInquirySuccessAction,
  getMyArtisanPrivateInquirySuccessAction,
  getMyArtisanPrivateInquiriesSuccessAction,
  setMyArtisanPrivateInquiryCountAction,
  getMyArtisanProposalsSucessAction,
  getMyArtisanProposalSuccessAction,
  editProposalByArtisanSuccessAction,
  addProposalByArtisanSuccessAction
} from './Actions';

import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../../notifications/Actions';

import {
  push
} from 'react-router-redux';


const body = {
  offset: 0,
  size: 10,
  searchTerm: '',
  filterBy: [{ moderated: false }], // for testing only value === true

  sort: 'createdAt',
  dir: 'asc',
};

function* getMyArtisanPrivateInquiries({ payload }) {
  const defBody = {...body, ...payload}
  try {
    yield put(setMyArtisanPrivateInquiryIsLoading(true));
    const response = yield call(api.getMyArtisanPrivateInquiries, defBody);
    const { data } = response;
    console.log('res',response)
    const {content, count} = data
    // console.log(content)
    yield put(getMyArtisanPrivateInquiriesSuccessAction(content));
    yield put(setMyArtisanPrivateInquiryCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPrivateInquiryIsLoading(false));
  }
}




function* getArtisanPrivateInquiry({ payload }) {
  const inquireyId = payload;
  const body = {
    inquiryID: inquireyId,
  };

  try {
    yield put(setMyArtisanPrivateInquiryIsLoading(true));
    const response = yield call(api.getMyArtisanPrivateInquiry, body);
    const { data } = response;
    
    console.log(data)
    yield put(getMyArtisanPrivateInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Get Private Inquiry'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPrivateInquiryIsLoading(false));
  }
}

function* getMyArtisanProposals({ payload }) {
  const defBody = {...body, ...payload}
  try {
    yield put(setMyArtisanPrivateInquiryIsLoading(true));
    const response = yield call(api.getMyArtisanPrivateInquiries, defBody);
    const { data } = response;
    const {content, count} = data
    console.log(content)
    yield put(getMyArtisanProposalsSucessAction(content));
    // for fixing temproary bug
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPrivateInquiryIsLoading(false));
  }
}
function* getArtisanProposal({ payload }) {
  const inquireyId = payload;
  const body = {
    inquiryID: inquireyId,
  };

  try {
    yield put(setMyArtisanPrivateInquiryIsLoading(true));
    const response = yield call(api.getMyArtisanPrivateInquiry, body);
    const { data } = response;
  
    console.log(data)
    yield put(getMyArtisanProposalSuccessAction(data));
    yield put(newSuccessNotificationAction('Get Private Inquiry'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPrivateInquiryIsLoading(false));
  }
}


function* addProposalByArtisan ({payload, trusted}) {
  try{
    yield put(setMyArtisanPrivateInquiryIsLoading(true));

    if (trusted) {
      
      const response = yield call(api.addProposalByArtisan, payload)
      // console.log(response)
      const {data} = response;
  
      yield put(addProposalByArtisanSuccessAction(data))
      yield put(newSuccessNotificationAction('Proposal Sent!'))
      yield put(push('/my-private-inquiries-artisan/'))
    } else {
       const response = yield call(api.addStagingProposalByArtisan, payload)
      // console.log(response)
      const {data} = response;
  
      // yield put(addProposalByArtisanSuccessAction(data))
      yield put(newSuccessNotificationAction('Proposal Sent! Pending'))
      yield put(push('/my-private-inquiries-artisan/'))
    }

  } catch(error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPrivateInquiryIsLoading(false));
  }
}



function* editProposalByArtisan ({payload, trusted}) {
  try{
      yield put(setMyArtisanPrivateInquiryIsLoading(true));
    if (trusted) {
      const response = yield call(api.editProposalByArtisan, payload)
      const {data} = response
      yield put(editProposalByArtisanSuccessAction(data))
      yield put(push('/my-private-inquiries-artisan/my-private-proposals/artisan/'))
      yield put(newSuccessNotificationAction('Edit Success!'))
    } else {
      const response = yield call(api.editStagingProposalByArtisan, payload)
      const {data} = response
      // yield put(editProposalByArtisanSuccessAction(data))
      yield put(push('/my-private-inquiries-artisan/my-private-proposals/artisan/'))
      yield put(newSuccessNotificationAction('Edit Success! Pending'))
    }

  } catch(error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPrivateInquiryIsLoading(false));
  }
}


export default function*() {
  yield takeLatest(
    actions.GET_MY_ARTISAN_PRIVATE_INQUIREY,
    getArtisanPrivateInquiry
  );
  yield takeLatest(
    actions.GET_MY_ARTISAN_PRIVATE_INQUIRIES,
    getMyArtisanPrivateInquiries
  );
  yield takeLatest(
    actions.ADD_PROSPOSAL_BY_ARTISAN,
    addProposalByArtisan
  )
  yield takeLatest(
    actions.GET_MY_ARTISAN_PROPOSALS,
    getMyArtisanProposals
  )
  yield takeLatest(
    actions.GET_MY_ARTISAN_PROPOSAL,
    getArtisanProposal
  )
  yield takeLatest(
    actions.EDIT_PROPOSAL_BY_ARTISAN,
    editProposalByArtisan
  )
}
